// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__15KGr","modalForm":"UpgradeEpcsModal_modalForm__UWK9j","modalFooter":"UpgradeEpcsModal_modalFooter__17OtO"};